var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTimeInState = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M13 0C5.85 0 0 5.85 0 13s5.85 13 13 13 13-5.85 13-13S20.15 0 13 0zm5.933 18L12 13.826V6h2v6.783l6 3.521L18.933 18z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTimeInState);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/time-in-state.5c8835e95cb945a76e433be77804639d.svg";